(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-terrain', {
                parent: 'app',
                url: '/tr-terrain',
                data: {
                    authorities: ['SECTION_SIDEBAR'],
                    pageTitle: 'trakeyeApp.terrain.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrains.html',
                        controller: 'TrTerrainController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    projectId: null,
                    routeId : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            projectId: $stateParams.projectId,
                            routeId :  $stateParams.routeId,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTerrain');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-terrain-detail', {
                parent: 'tr-terrain',
                url: '/tr-terrain/{id}',
                data: {
                    authorities: ['SECTION_DETAIL'],
                    pageTitle: 'trakeyeApp.terrain.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-detail.html',
                        controller: 'TrTerrainDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTerrain');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrTerrain', function ($stateParams, TrTerrain) {
                        return TrTerrain.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-terrain',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('tr-terrain.new', {
                parent: 'tr-terrain',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}/{sectionId}',
                data: {
                    authorities: ['SECTION_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-dialog.html',
                        controller: 'TrTerrainDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            terrainImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

        .state('tr-terrain.import', {
                parent: 'tr-terrain',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-import.html',
                        controller: 'TrTerrainImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            terrainImages: []
                        };
                    }
                }

            })
            .state('tr-terrain.edit', {
                parent: 'tr-terrain',
                url: '/Edit/{id}/{routeId}/{sectionId}',
                data: {
                    authorities: ['SECTION_EDIT'],
                    pageTitle: 'trakeyeApp.terrain.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-dialog.html',
                        controller: 'TrTerrainDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrTerrain', function ($stateParams, TrTerrain) {
                        return TrTerrain.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-terrain',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })
    }
})();